<template>
    <div class="www pt-2 pb-2 select-none">
        <div class="block pb-4 text-sm font-medium text-gray-700">
            {{ t('templateInsertRow') }}
        </div>
        <div class="rounded-md border border-gray-300 p-2">
            <div class="block pb-2 text-sm font-medium text-gray-700">
                {{ t('templateRowColCount') }}
            </div>
            <div class="px-2 pt-1 pb-8">
                <div class="tw-slider-primary">
                    <Vue3Slider
                        v-model="colSliderConfig.colCount"
                        color="var(--slider-color)"
                        track-color="var(--slider-track)"
                        :min="colSliderConfig.min"
                        :max="colSliderConfig.max"
                        :tooltip="true"
                        :handle-scale="2.1"
                        tooltip-text="%v cols"
                        tooltip-color="var(--slider-color)"
                        tooltip-text-color="var(--slider-text-color)"
                        :always-show-handle="true"
                        :flip-tooltip="true"
                        :disabled="!stateRepository.states.blockButtons"
                    />
                </div>
            </div>
            <div class="grid grid-cols-2 py-4">
                <ActionButton
                    :value="t('templateInsertRowBefore')"
                    state="primary"
                    :icon="MdiArrowExpandUp"
                    :is-disabled="!stateRepository.states.blockButtons"
                    :class-override="`rounded-none rounded-l-md ${
                        !stateRepository.states.blockButtons
                            ? 'border-r-gray-300'
                            : 'border-r-blue-300'
                    }`"
                    @click="insertBlock(templateEditModel, rowId, createBlock(blocks), true)"
                />
                <ActionButton
                    :value="t('templateInsertRowAfter')"
                    state="primary"
                    :icon="MdiArrowExpandDown"
                    :is-disabled="!stateRepository.states.blockButtons"
                    :class-override="`rounded-none rounded-r-md ${
                        !stateRepository.states.blockButtons
                            ? 'border-r-gray-300'
                            : 'border-r-blue-300'
                    }`"
                    @click="insertBlock(templateEditModel, rowId, createBlock(blocks), false)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch } from 'vue';
    import { defaultCol, createBlock, insertBlock } from '../composables/useTemplateModel';
    import { t } from '../composables/i18n';
    import Vue3Slider from 'vue3-slider';
    import ActionButton from '../ui/ActionButton.vue';
    import { MdiArrowExpandUp, MdiArrowExpandDown } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'BlockButtonsWidget',
    });

    const props = defineProps({
        templateEditModel: {
            type: Object,
            default: () => {
                return {};
            },
        },
        rowId: {
            type: String,
            default: '',
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const colSliderConfig = reactive({
        min: 1,
        max: 12,
        colCount: 1,
    });

    const templateEditModel = props.templateEditModel;
    const rowId = props.rowId;
    const stateRepository = props.stateRepository;

    const blocks = reactive([]);
    const updateBlocks = () => {
        blocks.length = 0;
        for (let i = 0; i < colSliderConfig.colCount; i++) {
            blocks.push(defaultCol);
        }
    };
    updateBlocks();

    watch(colSliderConfig, () => {
        updateBlocks();
    });
</script>
